import { Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  CrntFormControlHelpText,
  CrntFormControlLabel,
  CrntFormControlLabelIndicator,
  CrntRadio,
  CrntRadioGroup,
} from '@essent/current-web-angular';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { TrackValueChangeDirective } from '@analytics/events';

import { RfaFormControl, RfaValidators } from '../../../level1';
import type { RfaComponents } from '../RfaComponents';
import type { RfaValueChangeTrackerOptions } from '../../models/rfa-tracker-options.interface';
import { valueChangeOptionsToConfig } from '../../helpers/tracker-options-to-config';
import { RfaErrorsComponent } from '../utils/rfa-errors/rfa-errors.component';

@Component({
  selector: 'rfa-radio-group',
  standalone: true,
  templateUrl: './rfa-radio-group.component.html',
  imports: [
    ReactiveFormsModule,
    RfaErrorsComponent,
    CrntRadioGroup,
    CrntRadio,
    CrntFormControlLabel,
    CrntFormControlHelpText,
    CrntFormControlLabelIndicator,
    AutomationIdDirective,
    TrackValueChangeDirective,
  ],
  styleUrls: ['./rfa-radio-group.component.scss'],
})
export class RfaRadioGroupComponent {
  readonly control =
    input.required<
      RfaFormControl<
        (typeof RfaComponents.RadioGroup)['valueType'],
        typeof RfaComponents.RadioGroup
      >
    >();

  get radioGroupName(): string {
    return this.control().options.groupName ?? this.control().options.label;
  }

  get showOptional(): boolean {
    return !this.control().hasValidator(RfaValidators.required);
  }

  valueChangeTrackConfig() {
    const valueChangeOptions: RfaValueChangeTrackerOptions =
      this.control().options.analytics?.valueChangeTracker ?? {};

    return valueChangeOptionsToConfig(
      {
        ...valueChangeOptions,
        value: this.control().value.toString(),
      },
      {
        fieldName: this.control().options.label,
        hashValue: false,
      }
    );
  }
}
